export const reportTranslation = {
  filters_predefined_date: 3853,
  filters_search_placeholder: 7557,
  filters_date_placeholder: 7562,
  filters_date_range_to: 7600,
  filters_date_range_from: 7567,
  filters_date_range_date_interval: 3707,
  filters_date_range_date_fixed_period: 3706,
  filters_decimal_range: 7679,
  filters_exclude: 7638,
  filters_include: 7639,  
  filter_menu_options_desc_exclude: 7693,
  filter_menu_options_desc_exclude_sub: 7691,
  filter_menu_option_include: 7698,
  filter_menu_option_exclude: 7693,
  filter_menu_option_include_sub: 7696,
  filter_menu_option_exclude_sub: 7691,
  filters_my_unit: 7714,
  filters_my_location: 7715,
  report_title: 7731,
  report_subtitle: 7563,
  generate_title: 7565,
  generate_button: 7564,
  no_options_found: 7644,
  select_one_option: 7347,
  must_be_filled_out: 7598,
  report_generated: 7599,
  report_not_generated: 7634,
  report_started: 7993,
  report_success: 7873,
  remove_filter: 7662,
  done: 7338,
  cancel: 7904,
  submit: 7448,
  choose_file: 7907,
  upload_template: 8541,
  download_template: 8540,
  file_size_error: 8539,
  file_not_found: 8542,
  problem_uploading_file: 8538,
  upload_success: 8537,
  save_new_company_report: 8787,
  update_existing_company_report: 8821,
  scheduled_for_auto_execute: 6658,
  not_scheduled_for_auto_execute: 6659,
  schedule_title: 6756,
  add_schedule: 6757,
  edit_schedule: 6758,
  remove_schedule: 6760,
  invalid_email_error: 4710,
  report_sent_by_email: 8837,  
  some_fields_are_filled_out_incorrectly: 7702,
  save_schedule_success: 8895,
  save_schedule_failed:  8896,
  start: 6603,
  range_of_recurrence: 6604,
  occurences: 6605,
  recurrence_pattern: 6606,
  weeks_on: 6608,
  days: 6609,
  of_every: 6610,
  months: 6611,
  years: 6612,
  of: 6613,
  recur_every: 6614,
  execution_time: 6615,
  every: 8897,
  every_weekday: 8898,
  no_end_date: 8899,
  end_after: 8900,
  end_by: 8901,
  day: 8902,
  the: 8903,
  on_the: 8904,
  on: 8905,
  must_be_filled_out_in_schedule: 5949,
  show_details: 7640,
  hide_details: 7641,
  save_report: 7779,
  update_report: 8323,
  disabled: 5251,
  enter_email_recipients: 8955,
  failed_to_create_trigger: 8965,
  empty_date_error: 7968,
  reload_file: 8651,
  edit_company_report_config: 9064,
  manage_company_reports_option: 9065
};

export const maxLengthOfEmailsInputValue = 4000;

export const enum RecurrencePattern {
  Daily = 1,
  Weekly,
  Monthly,
  Yearly
}

export const enum RecurringRangeOptions {
  EndAfter = 1,
  EndBy,
  NoEndDate
}

export const enum RecurringYearlyOptions {
  onDayOfMonth = 1,
  onWeekday
}

export const enum RecurringMonthlyOptions {
  dayOfEveryMonth = 1,
  weekdayOfEveryMonth
}

export const enum RecurringDailyOptions {
  EveryDay = 1,
  EveryWeekday
}

export const RECUR_DEFAULT_HOURS: [number, number, number, number] = [23, 59, 59, 0];
export const TIME_MIDNIGHT_STRING  = '00:00';

export const enum ScheduleFieldKeys {
  executionTime = 'ExecutionTime',
  recurrencePattern = 'RecurrencePattern',
  recurrenceRange = 'RecurrenceRange',
  recurRangeStart = 'RecurRangeStart',
  recurRangeEndBy = 'RecurRangeEndBy',
  recurRangeEndAfter = 'RecurRangeEndAfter',
  recurDailyDaysInterval = 'RecurDaily.DaysInterval',
  recurDailyOption = 'RecurDaily.Option',
  recurWeeklyWeeksInterval = 'RecurWeekly.WeeksInterval',
  recurWeeklyDaysOfWeek = 'RecurWeekly.DaysOfWeek',
  recurMonthlyDaysOfWeek = 'RecurMonthly.DaysOfWeek',
  recurMonthlyDayOfMonth = 'RecurMonthly.DayOfMonth',
  recurMonthlyMonthsInterval = 'RecurMonthly.MonthsInterval',
  recurMonthlyOccurrence = 'RecurMonthly.Occurrence',
  recurMonthlyDayOfWeek = 'RecurMonthly.DayOfWeek',
  recurMonthlyOption = 'RecurMonthly.Option',
  recurYearlyOption = 'RecurYearly.Option',
  recurYearlyYearsInterval = 'RecurYearly.YearsInterval',
  recurYearlyDayOfMonth = 'RecurYearly.DayOfMonth',
  recurYearlyMonth1 = 'RecurYearly.Month1',
  recurYearlyMonth2 = 'RecurYearly.Month2',
  recurYearlyOccurence = 'RecurYearly.Occurrence',
  recurYearlyDayOfWeek = 'RecurYearly.DayOfWeek'
}
